import { newLogoReachOk64 } from 'reports/base64Images';
import theme from 'source/theme';
import arrayToObject from 'utils/arrayToObject';
import { DESCRIPTOR_TYPES, DESCRIPTORS_WITH_CONDITIONS_TYPES, ERC, PROC } from 'utils/constants/descriptorTypes';
import { shortDate } from 'utils/helperFunctions/dateFormat';

const themeLight = theme.palette.primary.light;
const themeMain = theme.palette.primary.main;
const lightGrey = '#EEEEEE';

const rowGenerator = (substance, scenarios, data) => {
  const {
    conditionsData, descriptorsData, descriptorsById, scenarioDescriptorsData,
    scenarioDescriptorConditionsData
  } = data;

  const rows = [];

  const conditionsFilter = {
    [ERC]: 'Ambiente',
    [PROC]: 'Trabalhadores'
  };

  const descriptorInjector = (rows, descriptor, fSDByDescriptorId) => {
    const ok_flag = fSDByDescriptorId[descriptor.id] && fSDByDescriptorId[descriptor.id].ok_flag;
    const notes = fSDByDescriptorId[descriptor.id] && fSDByDescriptorId[descriptor.id].notes;

    rows.push([
      { text: descriptor.code, alignment: 'left', bold: true },
      { text: descriptor.description, alignment: 'left', colSpan: 3, bold: true },
      {},
      {},
      { text: ok_flag ? 'OK' : 'NOT OK', alignment: 'center', bold: true },
      { text: notes, alignment: 'left', bold: true }
    ]);

  };

  const conditionInjector = (rows, condition, fsdcByConditionId) => {
    const valor = fsdcByConditionId[condition.id].value;
    const unit_id = fsdcByConditionId[condition.id].unit_id;
    const ok_flag = fsdcByConditionId[condition.id].ok_flag;
    const notes = fsdcByConditionId[condition.id].notes;

    rows.push([
      { text: '', border: [false, false, false, false] },
      { text: valor, alignment: 'left' },
      { text: unit_id ? data.unitsById[parseInt(unit_id)].name : '', alignment: 'left' },
      { text: condition.name, alignment: 'left' },
      { text: ok_flag ? 'OK' : 'NOT OK', alignment: 'center' },
      { text: notes, alignment: 'left' }
    ]);
  };

  // Substance
  rows.push([
    { text: substance.name,  fillColor: themeMain, colSpan: 3, margin: [10, 0, 0, 0] },
    {},
    {},
    { text: `CAS: ${substance.cas}`, fillColor: themeMain, colSpan: 2 },
    {},
    { text: `EC: ${substance.ec}`, fillColor: themeMain },
  ]);

  scenarios.map(scenario => {

    //LCS
    rows.push([
      { text: data.lcsById[scenario.lcs_id].code, fillColor: themeLight, colSpan: 2, margin: [10, 0, 0, 0] },
      {},
      { text: data.lcsById[scenario.lcs_id].description, fillColor: themeLight, colSpan: 4 },
      {},
      {},
      {}
    ]);

    //Supplier shipment
    const shipment = data.shipmentsById[scenario.raw_material_supplier_id];
    const supplier = data.suppliersById[shipment.supplier_id];
    rows.push([
      { text: supplier.name, alignment: 'left', fillColor: lightGrey, colSpan: 3, margin: [10, 0, 0, 0] },
      {},
      {},
      { text: shipment.trade_name, alignment: 'left', fillColor: lightGrey, colSpan: 1 },
      { text: `Data FDS ${shortDate(shipment.sds_date)}`, fillColor: lightGrey, colSpan: 2 },
      {}
    ]);

    //scenario
    rows.push([
      { text: scenario.code, alignment: 'left', fillColor: lightGrey, colSpan: 2, margin: [10, 0, 0, 0] },
      {},
      { text: scenario.designation, alignment: 'left', fillColor: lightGrey, colSpan: 2 },
      {},
      { text: scenario.notes, alignment: 'left', fillColor: lightGrey, colSpan: 2 },
      {}
    ]);


    DESCRIPTOR_TYPES.forEach(descriptorFilter => {

      const filteredDescriptors = descriptorsData.filter(v => v.descriptor_type_id === descriptorFilter);
      const filteredScenarioDescriptors = scenarioDescriptorsData.filter(sd =>
        sd.scenario_id === scenario.id &&
        descriptorsById[sd.descriptor_id].descriptor_type_id == descriptorFilter
      );
      const fSDByDescriptorId = arrayToObject(filteredScenarioDescriptors, 'descriptor_id');
      const selectedDescriptorIds = filteredScenarioDescriptors.map(fsd => fsd.descriptor_id);

      filteredDescriptors.forEach(descriptor => {

        // Inject descriptor on rows
        if (selectedDescriptorIds.includes(descriptor.id)) {

          descriptorInjector(rows, descriptor, fSDByDescriptorId);

          // Inject conditions on rows
          // Only used for ERC and PROC
          if (DESCRIPTORS_WITH_CONDITIONS_TYPES.includes(descriptorFilter)) {

            const scenarioDescriptor = fSDByDescriptorId[descriptor.id];
            const filteredConditions = conditionsData.filter(condition =>
              condition.type === conditionsFilter[descriptorFilter]
            );

            const filteredSDC = scenarioDescriptorConditionsData.filter(sdc =>
              sdc.scenario_descriptor_id === scenarioDescriptor.id
            );

            const fsdcByConditionId = arrayToObject(filteredSDC, 'condition_id');
            const selectedConditionsIds = filteredSDC.map(fsdc => fsdc.condition_id);

            filteredConditions.forEach(condition => {

              if (selectedConditionsIds.includes(condition.id)) {
                // Inject conditions on rows
                conditionInjector(rows, condition, fsdcByConditionId);
              }
            });
          }
        }
      });
    });
  });

  return rows;

};

const dd = (substance, scenarios, data, title) => ({
  pageSize: 'A4',
  pageOrientation: 'portrait',
  pageMargins: [30, 60, 30, 40],

  footer: function (currentPage, pageCount) {
    return {
      text: `${shortDate(new Date())} - ${currentPage.toString()} de ${pageCount}`,
      alignment: 'right',
      relativePosition: { x: -15, y: 20 },
      fontSize: 7
    };
  },
  header: function (currentPage, pageCount, pageSize) {
    return [
      {
        image: newLogoReachOk64,
        width: 50,
        relativePosition: { x: 20, y: 10 }
      }
    ];
  },
  content: [
    {
      style: 'header',
      text: title //title,
    },
    {
      style: 'tableExample',
      layout: 'lightHorizontalLines',
      table: {
        headerRows: 0,
        widths: [30, 30, 40, 160, 40, 150],
        body: [
          ...rowGenerator(substance, scenarios, data)
        ]
      }
    }
  ],
  styles: {
    header: {
      color: theme.palette.primary.main,
      fontSize: 14,
      bold: true,
      alignment: 'center'
    },
    tableExample: {
      margin: [0, 15, 0, 0],
      fontSize: 7
    }
  }

});

export default dd;
